import TimePicker from "react-time-picker";

const TimePickerField = ({ name, value, onChange, disabled = false }) => {
  return (
    <TimePicker
      className="bg-white text-center"
      name={name}
      value={value}
      onChange={onChange}
      clearIcon={null}
      format="HH:mm"
      disableClock
      disabled={disabled}
    />
  );
};

export default TimePickerField;
